import request, { deAxios } from '@/utils/request'
import querystring from 'querystring'
import { User } from '@/types'
import get from 'lodash/get'
import { AxiosRequestConfig } from 'axios'

const apiFactory = () => {
  const me = (): Promise<User.API.ReqRes.Me.Response> => {
    return request({
      url: '/cadence-service/patients/me',
      method: 'get'
    })
      .then(deAxios)
  }
  const login = ({ username, password }: User.API.ReqRes.Login.Credentials): Promise<User.API.ReqRes.Login.Response> => {
    return request({
      method: 'post',
      url: '/cadence-service/oauth/token',
      data: querystring.stringify({
        grant_type: 'password',
        username,
        password
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        User: 'Y2FkZW5jZTpjYWRlbmNlX3NlY3JldA=='
      }
    })
      .then(deAxios)
  }
  const activate = (refresh_token?: string): Promise<User.API.ReqRes.Login.Response> => {
    return request({
      method: 'post',
      url: '/cadence-service/oauth/activate-patient',
      data: querystring.stringify({
        grant_type: 'refresh_token',
        refresh_token
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        User: 'Y2FkZW5jZTpjYWRlbmNlX3NlY3JldA=='
      }
    })
      .then(deAxios)
  }
  const retryFailedRequest = (config: AxiosRequestConfig) => {
    return request(config)
  }
  const refreshToken = (refresh_token?: string): Promise<User.API.ReqRes.Login.Response> => {
    return request({
      method: 'post',
      url: '/cadence-service/oauth/token',
      data: querystring.stringify({
        grant_type: 'refresh_token',
        refresh_token
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        User: 'Y2FkZW5jZTpjYWRlbmNlX3NlY3JldA=='
      }
    })
      .then(deAxios)
  }
  const acceptAgreement = (agreementType: User.AgreementTypes) => {
    const keyMap: Record<User.AgreementTypes, string> = {
      tos: 'accept-tos-2',
      privacy: 'accept-privacy-policy-2'
    }
    return request({
      url: `/cadence-service/${keyMap[agreementType]}`,
      method: 'post'
    })
  }
  const getAcceptedAgreements = (): Promise<User.AcceptedAgreements> => {
    const keyMap: Partial<Record<User.API.ReqRes.UserInfo.ItemType, User.AgreementTypes>> = {
      CADENCE_TOS_2: 'tos',
      CADENCE_PRIVACY_POLICY_2: 'privacy'
    }
    return request({
      url: '/cadence-service/user-info',
      method: 'get'
    })
      .then(deAxios)
      .then(
        (data: User.API.ReqRes.UserInfo.Items) => data.reduce(
          (acc, userInfoItem) => {
            const key = get(keyMap, userInfoItem.type)
            if (key) {
              acc.push(key)
            }
            return acc
          }, [] as User.AcceptedAgreements
        )
      )
  }
  const getReportURL = () => {
    return request({
      url: '/cadence-service/reports/me/final-report/pdf',
      method: 'get',
      responseType: 'blob'
    })
      .then(deAxios)
      .then(data => new Blob([data], { type: 'application/pdf' }))
      .then(data => window.URL.createObjectURL(data))
  }

  return {
    login,
    me,
    activate,
    refreshToken,
    retryFailedRequest,
    getAcceptedAgreements,
    acceptAgreement,
    getReportURL
  }
}

export default apiFactory
